
// Main imports 
import React, { useState } from "react";
import {
  Grid,
  CircularProgress,
  Typography,
  Button,
  TextField,
  Fade,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";

// Local imports 
import img from '../../images/login_school_background.png';

// styles
import useStyles from "./styles";

// context
import { useUserDispatch, loginAdminUser } from "../../context/UserContext";
import { getServiceName } from "../../utils/consts";
import moment from "moment";

function Login(props) {
  var classes = useStyles();

  // global
  var userDispatch = useUserDispatch();

  // local
  var [isLoading, setIsLoading] = useState(false);
  var [error, setError] = useState(null);
  var [loginValue, setLoginValue] = useState("");
  var [passwordValue, setPasswordValue] = useState("");

  document.title = getServiceName() + ' - Admin login';

  return (
    <Grid container className={classes.container}>
      <div className={classes.logotypeContainer}>
        <img alt="" src={img} style={{height: '100%', width: '100%', flex: 1, resize: 'contain'}} />
      </div>
      <div className={classes.formContainer}>
        <div className={classes.form}>
            <React.Fragment>
              <Typography variant="h1" className={classes.greeting}>
                Gestionale avanzato
              </Typography>
              <Fade in={error}>
                <Typography color="secondary" className={classes.errorMessage}>
                  Ops... qualcosa non va :(
                </Typography>
              </Fade>
              <TextField
                id="email"
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
                value={loginValue}
                onChange={e => setLoginValue(e.target.value)}
                margin="normal"
                placeholder="Username"
                type="text"
                fullWidth
              />
              <TextField
                id="password"
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
                value={passwordValue}
                onChange={e => setPasswordValue(e.target.value)}
                margin="normal"
                placeholder="Password"
                type="password"
                fullWidth
              />
              <div className={classes.formButtons}>
                {isLoading ? (
                  <CircularProgress size={26} className={classes.loginLoader} />
                ) : (
                  <Button
                    disabled={
                      loginValue.length === 0 || passwordValue.length === 0
                    }
                    onClick={ async () => {
                      
                        await loginAdminUser(
                          userDispatch,
                          loginValue,
                          passwordValue,
                          props.history,
                          setIsLoading,
                          setError,
                        )
                      }
                    }
                    variant="contained"
                    color="primary"
                    size="large"
                  >
                    Accedi
                  </Button>
                )}
              </div>
            </React.Fragment>
        </div>
        <Typography color="primary" className={classes.copyright}>
          © 2021-{moment().format('yyyy')} APPIUS. Tutti i diritti riservati.
        </Typography>
      </div>
    </Grid>
  );
}

export default withRouter(Login);
